/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FieldInfo, ProjectWellVsps } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class GeologyClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Geology
   * @summary Получить месторождения проекта из геологии, отсортированные в порядке списка месторождений из дерева
   * @request GET:/bff/Geology/project/{projectId}/fields
   * @secure
   */
  geologyGetFieldsInProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<FieldInfo[], any>({
      path: `/bff/Geology/project/${projectId}/fields`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Geology
   * @summary Получить скважины с ВСП из геологии по проекту и месторождению, синхронизированные с ВСП дерева
   * @request GET:/bff/Geology/project/{projectId}/vsp/field/{fieldId}
   * @secure
   */
  geologyGetWellsWithVspInProject = (
    projectId: string,
    fieldId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectWellVsps[], any>({
      path: `/bff/Geology/project/${projectId}/vsp/field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
